// extracted by mini-css-extract-plugin
export default {"content":"index_content_90sw8 clearfix"};